export default "__VITE_ASSET__CKCaxB3Y__"